import { Checkbox, Grid, Paper, Tooltip, Typography } from '@mui/material'
import { CarrierVisitDirection, HoldStatus } from '@planning/app/api'
import { HoldWithDirection } from '@planning/components/hold/HoldListBox'
import { useTranslate } from '@tolgee/react'
import { CheckOvalIcon, RemoveIcon, useMinimalsTheme } from '@tom-ui/ui'
import { FC } from 'react'
import { ContainerDirectionChip } from '../ContainerDirectionChip'

interface Props {
  hold: HoldWithDirection
  showDirection?: boolean
  checked?: boolean
  onCheck?: (requestId: number) => void
}

export const HoldListCard: FC<Props> = ({ hold, showDirection, checked, onCheck }) => {
  const { t } = useTranslate()
  const theme = useMinimalsTheme()

  const getIcon = () => {
    const isActive = hold.status === HoldStatus.Active
    return (
      <Tooltip title={isActive ? t('active', 'Active') : t('resolved', 'Resolved')}>
        {isActive ? <RemoveIcon /> : <CheckOvalIcon />}
      </Tooltip>
    )
  }

  return (
    <Paper variant='outlined' sx={{ width: '100%', mt: 1, py: theme.customSpacing.xxs }}>
      <Grid container>
        <Grid mr={theme.customSpacing.xs} size={1}>
          {(checked !== undefined && onCheck && (
            <Checkbox checked={checked} onClick={() => onCheck(hold.id)} />
          )) || <></>}
        </Grid>
        <Grid display='flex' flexDirection='column' justifyContent='center' size='grow'>
          <Typography variant='subtitle2'>{hold.reason}</Typography>
          <Typography variant='body2'>{`${t('contact', 'Contact')}: ${hold.contact}`}</Typography>
        </Grid>
        {showDirection && (
          <Grid display='flex' justifyContent='center' alignItems='center' size={2}>
            <ContainerDirectionChip
              direction={hold.direction}
              label={
                hold.direction === CarrierVisitDirection.Inbound ? t('in', 'In') : t('out', 'Out')
              }
            />
          </Grid>
        )}
        <Grid display='flex' justifyContent='center' alignItems='center' size={2}>
          {getIcon()}
        </Grid>
      </Grid>
    </Paper>
  )
}
